import { useEffect } from "react";
import { gql } from "__generated__/gql";
import { intl } from "LocaleWrapper";
import { Table } from "@cofano/cck";
import "./declarations.scss";
import { DateUtils } from "utils/DateUtils";
import { TableId, useBackendTable } from "components/table";
import client from "../../apollo";

const NonPurchaseShips = ({ onChange, window, updateNonPurchaseShipRequestId, onHasNonPurchaseShips }) => {

	const { tableProps, refetch } = useBackendTable({
		id: TableId.DeclarationNonPurchaseShips,
		onChange: async (pagination, sort, filter, callback) => {
			const from = DateUtils.getTimestamp(window.from);
			const to = DateUtils.getTimestamp(window.to);

			try {
				const result = await client.query({
					query: query,
					variables: {
						search: {
							windowFrom: from,
							windowTo: to,
						},
						pagination: {
							...pagination,
							sortList: sort,
						},
					},
				});

				callback({
					content: result.data.nonPurchaseShips.content,
					totalResults: result.data.nonPurchaseShips.totalElements,
				});
				onChange(result.data.nonPurchaseShips.content);
				onHasNonPurchaseShips(result.data.nonPurchaseShips.totalElements > 0);
			} catch {
				callback({
					content: [],
					totalResults: 0,
				});
			}
		},
	});

	useEffect(() => {
		refetch();
	}, [ updateNonPurchaseShipRequestId, window.from, window.to ]);

	return (
		<Table
			{...tableProps}
			key={updateNonPurchaseShipRequestId}
			columns={[ {
				id: "ship",
				title: intl.formatMessage({ id: "SHIP" }),
				render: (row) => {
					return row.name ?? "";
				},
			} ]}
			columnResizingEnabled={false}
		/>
	);
};


const query = gql(`#graphql
	query nonPurchaseShips_nonPurchaseShips($search: VoyageSearchObject!, $pagination: Pagination!) {
		nonPurchaseShips(search: $search, excludeEmpty: true, pagination: $pagination) {
			totalElements
			content {
				id
				name
			}
		}
	}
`);

export default NonPurchaseShips;
